import type { BalconyProfile } from "./model";

export const standardProfile: BalconyProfile = {
  widthCm: 320,
  depthCm: 145,
  doorType: "sliding",
  direction: "Đông Nam",
  directSunHours: "2–4 giờ",
  light: "morning",
  wind: "normal",
  waterAccess: "near",
  budget: 18000000,
  care: "medium",
  styleId: "tropical-soft",
  hasKids: false,
  hasPets: true,
};

export const noFitProfile: BalconyProfile = {
  ...standardProfile,
  widthCm: 120,
  depthCm: 60,
  budget: 8000000,
};

export const budgetProfile: BalconyProfile = {
  ...standardProfile,
  widthCm: 280,
  depthCm: 145,
  direction: "Tây",
  directSunHours: "5–7 giờ",
  light: "harsh",
  wind: "windy",
  budget: 9000000,
  care: "medium",
  styleId: "edible-wood",
  hasPets: false,
};
